"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Menu_1 = require("./Menu");
exports.default = Menu_1.default;
//# sourceMappingURL=index.js.map